import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { HttpService } from 'src/app/http.service';
import { StorageService } from 'src/app/storage.service';
import { TimeService } from 'src/app/time.service';
import { ValidationService } from 'src/app/validation.service';
import { SnackbarService } from 'src/app/snackbar.service';
import { DateTime } from 'luxon';

import {Messages} from '../../constants/messages';
import { environment } from 'src/environments/environment';
declare var google: any;

export interface Driver {
  id?: string;
  name: string;
  mobile: string;
  password?: string;
  driver_type: string;
  licence: {
    no: string,
    expiry_date: number
  };
  city?: string;
  home_location?: {
    latitude: number,
    longitude: number,
    address: string
  };
  profile_pic?: File;
  has_smart_phone: boolean;
  ws_opt_in:boolean
}

@Component({
  selector: 'app-add-driver',
  templateUrl: './add-driver.component.html',
  styleUrls: ['./add-driver.component.scss']
})
export class AddDriverComponent implements OnInit {

  map;
  mapMarker: any = [];
  newDriverData: Driver = {
    name: '',
    mobile: '',
    password: '',
    driver_type: '',
    licence: {
      no: '',
      expiry_date: 0
    },
    home_location: {
      latitude: 0,
      longitude: 0,
      address: ''
    },
    has_smart_phone: false,
    ws_opt_in:false
  };
  cityArray: any = {};
  formData = new FormData();
  driverType = [{ // contracted, aggregated, temporary
    name: 'Contracted',
    val: 'contracted'
  }, {
    name: 'Aggregated',
    val: 'aggregated'
  }, {
    name: 'Own',
    val: 'own'
  }];
  address: '';
  expiryDate: any = '';
  confirmPassword = '';
  editDriver: any = {};
  editFlag = false;
  edit_heading = false;

  messages = new Messages();
  showVerifyLinks = false;
  optIn = false;
  showLoader = false;

  constructor(private dialog: MatDialogRef<AddDriverComponent>, private http: HttpService, private storage: StorageService,
              private timeService: TimeService, private valid: ValidationService, private snackbar: SnackbarService,
              @Inject(MAT_DIALOG_DATA) private parentData: any) { }

  ngOnInit() {

    this.showVerifyLinks = environment.country === 'IN';

    if (this.parentData.driverData) {
      this.edit_heading = true;
    }
    this.initAutoSuggestions();
    this.initMap();
    this.getCity();
    if (this.parentData.driverData) {
      this.editDriver = this.parentData.driverData;
      this.editFlag = true;
      this.initDriverEdit();
    }
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const marker = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        this.map.setCenter(marker);
      });
    }
  }

  openVerifyModal(url) {
    window.open(url, '_blank');
  }

  initDriverEdit() {
    this.newDriverData.id = this.editDriver._id;
    this.newDriverData.name = this.editDriver.driverName;
    this.newDriverData.mobile = this.editDriver.driverMobile;
    this.newDriverData.ws_opt_in = this.editDriver.ws_opt_in;
    delete this.newDriverData.password;
    this.newDriverData.licence.no = this.editDriver.licence.no;
    this.expiryDate = this.editDriver.licence.expiry_date;
    this.setExpiryDate(this.expiryDate);
    this.newDriverData.driver_type = this.editDriver.driver_type.toLowerCase();
    if (this.editFlag) {
      delete this.newDriverData.city;
    } else {

      this.newDriverData.city = this.editDriver.city;
    }
    if(this.editDriver.home_location){
      this.newDriverData.home_location = this.editDriver.home_location ;
      this.address = this.editDriver.home_location.address;
      this.placeMarker(this.newDriverData.home_location);
    }
  }

  fileChanged(event: any) {
    this.formData.append('profile_pic', event.target.files[0], event.target.files[0].name);
  }

  submit() {
    const val = this.validate();
    if (val) {
      let url = '';
      (this.editFlag) ? url = 'v2/driver/edit' : url = 'v2/driver/add' ;

      
      this.showLoader = true;
      this.http.post(url, this.newDriverData).subscribe(
        (data: any) => {
          this.showLoader = false;
          if (data.statusCode == 200) {
            this.snackbar.openSnackBar(this.messages.EDITDRIVER.SUCCESS.UPDATE, '');
            this.dialog.close(data);
          }
        },
        (err: any) => {
          this.showLoader = false;
          console.log('er-=', err);
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        }
      );
    }
  }

  validate() {
    const now: any = DateTime.local();

    if (this.editFlag) {
      if (!this.valid.isEmpty(this.newDriverData.name) && !this.valid.isEmpty(this.newDriverData.mobile) && !this.valid.isEmpty(this.newDriverData.driver_type)
          && !this.valid.isEmpty(this.newDriverData.licence.no) && (this.newDriverData.licence.expiry_date > 0) && !this.valid.isEmpty(this.newDriverData.home_location.address)) {
            if (!this.valid.isMobile(this.newDriverData.mobile)) {
              this.snackbar.openSnackBar(this.messages.DRIVERS.DRIVER_ADD.ERROR.MOBILE_NUMBER_VALID, '', 'err');
              return false;
            } else if (this.newDriverData.licence.expiry_date <= now.ts) {
              this.snackbar.openSnackBar(this.messages.DRIVERS.DRIVER_ADD.VALIDATION.LICENCE_EXPIRY, '', 'err');
              return false;
            } else {
              return true;
            }
      } else {
        this.snackbar.openSnackBar(this.messages.DRIVERS.DRIVER_ADD.VALIDATION.FILL_ALL, '', 'err');
        return false;
      }
    } else if (!this.valid.isEmpty(this.newDriverData.name) && !this.valid.isEmpty(this.newDriverData.mobile) && !this.valid.isEmpty(this.newDriverData.password)
        && !this.valid.isEmpty(this.confirmPassword) && !this.valid.isEmpty(this.newDriverData.driver_type) && !this.valid.isEmpty(this.newDriverData.licence.no)
        && (this.newDriverData.licence.expiry_date > 0) && !this.valid.isEmpty(this.newDriverData.home_location.address)) {

          if (!this.valid.isMobile(this.newDriverData.mobile)) {
            this.snackbar.openSnackBar(this.messages.DRIVERS.DRIVER_ADD.ERROR.MOBILE_NUMBER_VALID, '', 'err');
            return false;
          } else if (!this.valid.isPassword(this.newDriverData.password) || !this.valid.isPassword(this.confirmPassword)) {
            this.snackbar.openSnackBar(this.messages.DRIVERS.DRIVER_ADD.VALIDATION.PASSWORD_LENGTH, '', 'err');
            return false;
          } else if (this.newDriverData.password !== this.confirmPassword) {
            this.snackbar.openSnackBar(this.messages.DRIVERS.DRIVER_ADD.VALIDATION.PASSWORD_MATCH, '', 'err');
            return false;
          } else if (this.newDriverData.licence.expiry_date <= now.ts) {
            this.snackbar.openSnackBar(this.messages.DRIVERS.DRIVER_ADD.VALIDATION.LICENCE_EXPIRY, '', 'err');
            return false;
          } else {
            return true;
          }
    } else {
      this.snackbar.openSnackBar(this.messages.DRIVERS.DRIVER_ADD.VALIDATION.FILL_ALL, '', 'err');
      return false;
    }
  }

  closeDialog() {
    this.dialog.close();
  }

  setExpiryDate(date, change= '') {
    if (this.editFlag && !change) {
      const temp: any =  this.timeService.IsoToUTC(date);
      this.newDriverData.licence.expiry_date = temp.ts;
    } else {
      this.newDriverData.licence.expiry_date = this.timeService.toUTCEpoch(date);
    }
  }

  getCity() {
    this.cityArray = JSON.parse(this.storage.getFromLocalStorage('cities'));
  }

  initMap(lat = 0, lng = 0) {
    const marker = {
      latitude: lat,
      longitude: lng
    };
    const mapProp = {
      center: new google.maps.LatLng(lat, lng),
      zoom: 12,
      mapTypeControl: true,
      scaleControl: false,
      streetViewControl: false,
      zoomControl: true,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
      }
      // styles: this.mapStyle,
    };
    this.map = new google.maps.Map(document.getElementById('pathMap'), mapProp);
    google.maps.event.addListener(this.map, 'click', function(event) {
    });

  }

  placeMarker(location) {
    this.mapMarker.forEach(element => element.setMap(null));
    this.mapMarker.length = 0;
    const marker = new google.maps.Marker({
      position: { lat: parseFloat(location.latitude), lng: parseFloat(location.longitude) },
      map: this.map,
      // label: label || ''
    });

    this.mapMarker.push(marker);
    marker.setMap(this.map);
    this.map.setCenter({ lat: parseFloat(location.latitude), lng: parseFloat(location.longitude) });

  }

  initAutoSuggestions() {

    const input = document.getElementById('addressSearch');
    const options = {};

    const autoComplete = new google.maps.places.Autocomplete(input, options);

    const context = this.newDriverData;
    autoComplete.addListener('place_changed', () => {

      const place = autoComplete.getPlace();
      context.home_location.latitude = place.geometry.location.lat();
      context.home_location.longitude = place.geometry.location.lng();
      context.home_location.address = place.formatted_address;

      this.placeMarker(context.home_location);
      if (!place.geometry) {
        return;
      }
    });
  }
}
